<script setup>
import { ref, watch, computed } from "vue";
import { formatMoney, equals as moneyAreEquals } from "../../utils/money.ts";
import InputPrice from "@/components/ui/InputPrice.vue";
import QuotaIndicator from "@/components/QuotaIndicator.vue";

const props = defineProps({
  activity: {
    type: Object,
    required: true,
  },
  variant: {
    type: Object,
    required: true,
  },
  orderItemPrice: {
    default: null,
  },
  orderItemInitialPrice: {
    default: null,
  },
  updatePrice: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "price-change"
]);

const showInputPrice = ref(false);
const price = ref(props.activity.price);
const initialPrice = ref(props.orderItemPrice);

watch(
  () => props.variant,
  () => {
    showInputPrice.value = false;
  }
);

const onClickEditPrice = () => {
  price.value = props.activity.price.amount;
  emit("price-change", props.activity.price);
  showInputPrice.value = true;
};

const onDiscard = () => {
  showInputPrice.value = false;
  price.value = initialPrice.value;
  emit("price-change", initialPrice.value);
};

const onPriceChange = (newPrice) => {
  const moneyPrice = {
    amount: newPrice,
    currency: props.activity.price.currency,
  };
  emit("price-change", moneyPrice);
};

if (
  props.updatePrice &&
  props.orderItemPrice !== props.activity.price
) {
  emit("price-change", props.activity.price);
}
</script>
<template>
  <div class="bg-light d-flex justify-content-between p-3">
    <div v-if="variant.quota" class="align-self-center pr-3">
      {{ $t('Quota:') }}
      <QuotaIndicator :quota="variant.quota" style="width: 150px" />
    </div>
    <div class="align-self-center ml-auto">
      <div :class="['text-nowrap text-right']">
        {{ formatMoney(orderItemPrice) }}
        <a href @click.prevent="onClickEditPrice">
          <i class="fa fa-edit"></i>
        </a>
      </div>
      <InputPrice
        v-if="showInputPrice"
        :currency="activity.price?.currency"
        :model-value="activity.price?.amount"
        with-discard
        class="input-group-sm"
        @discard="onDiscard"
        @update:model-value="onPriceChange"
      ></InputPrice>

      <div v-else class="text-nowrap">
        <div
          v-if="orderItemInitialPrice && orderItemPrice !== orderItemInitialPrice"
          class="text-danger"
        >
          {{ $t('Current price:') }}
          {{ formatMoney(orderItemInitialPrice) }}
        </div>
        <div
          v-if="!moneyAreEquals(orderItemPrice, activity?.price)"
          class="text-danger"
        >
          {{ $t('Activity price:') }}
          {{ formatMoney(activity.price) }}
        </div>
      </div>
    </div>
  </div>
</template>